module.exports = __webpack_public_path__ + "img/fondoiglu.8c41534f.png";